module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/address/postcode.js
 ** module id = 1060
 ** module chunks = 0
 **/